import axios from 'axios';

const state = () => ({
  loadingPersons: false,
  loadingPersonSurveys: false,
  loadingPersonQuestionModel: false,
  persons: [],
  personSurveys: [],
  selectedPersonId: '',
  personEvents: [],
  showPersonSurveys: true,
  personEventData: new Array(4),
  activePersonComponent: '',
  personQuestionFormData: null,
  showPersonQuestionModel: true,
  personQuestionModel: [],
  dirtyPersonSurvey: false,
});

const getters = {
  loadingPersons: state => {
    return state.loadingPersons;
  },
  loadingPersonSurveys: state => {
    return state.loadingPersonSurveys;
  },
  loadingPersonQuestionModel: state => {
    return state.loadingPersonQuestionModel;
  },
  persons: state => {
    return state.persons;
  },
  selectedPersonId: state => {
    return state.selectedPersonId;
  },
  personEvents: state => {
    return state.personEvents;
  },
  showPersonSurveys: state => {
    return state.showPersonSurveys;
  },
  personEventData: state => {
    return state.personEventData;
  },
  personSurveys: state => {
    return state.personSurveys;
  },
  activePersonComponent: state => {
    return state.activePersonComponent;
  },
  personQuestionFormData: state => {
    return state.personQuestionFormData;
  },
  showPersonQuestionModel: state => {
    return state.showPersonQuestionModel;
  },
  personQuestionModel: state => {
    return state.personQuestionModel;
  },
  dirtyPersonSurvey: state => {
    return state.dirtyPersonSurvey;
  },
};

const mutations = {
  loadingPersons(state, loadingPersons) {
    state.loadingPersons = loadingPersons;
  },
  loadingPersonSurveys(state, loadingPersonSurveys) {
    state.loadingPersonSurveys = loadingPersonSurveys;
  },
  loadingPersonQuestionModel(state, loadingPersonQuestionModel) {
    state.loadingPersonQuestionModel = loadingPersonQuestionModel;
  },
  persons(state, persons) {
    state.persons = persons;
  },
  selectedPersonId(state, selectedPersonId) {
    state.selectedPersonId = selectedPersonId;
  },
  personEvents(state, personEvents) {
    state.personEvents = personEvents;
  },
  showPersonSurveys(state, showPersonSurveys) {
    state.showPersonSurveys = showPersonSurveys;
  },
  personEventData(state, personEventData) {
    state.personEventData = personEventData;
  },
  personSurveys(state, personSurveys) {
    state.personSurveys = personSurveys;
  },
  activePersonComponent(state, activePersonComponent) {
    state.activePersonComponent = activePersonComponent;
  },
  personQuestionFormData(state, personQuestionFormData) {
    state.personQuestionFormData = personQuestionFormData;
  },
  personQuestionModel(state, personQuestionModel) {
    state.personQuestionModel = personQuestionModel;
  },
  showPersonQuestionModel(state, showPersonQuestionModel) {
    state.showPersonQuestionModel = showPersonQuestionModel;
  },
  dirtyPersonSurvey(state, dirtyPersonSurvey) {
    state.dirtyPersonSurvey = dirtyPersonSurvey;
  },
};

export const actions = {
  async getPersons({ getters, commit }) {
    try {
      commit('loadingPersons', true);
      let response = await axios.get(`/api/get-person-state-info/${'personSurveys'}`);
      commit('persons', response.data.records);
      commit('loadingPersons', false);
    } catch (error) {
      if (error.response.status === 500) {
        console.error('getting 500!');
        alert('Server is not responding, please try again later');
      } else if (error.response.status === 404) {
        console.error('getting 404!');
        alert('We could not find the persons, please try again later');
      } else if (error.response.status === 401) {
        alert('Your session seems to have ended, please refresh');
      } else if (error.response.status === 400) {
        alert(
          'Your request could not be proccessed, please try to refresh your page or contact support',
        );
      }
      commit('persons', []);
      commit('loadingPersons', false);
      console.log(error);
    }
  },
  async getPersonEvents({ getters, commit }) {
    try {
      commit('hideEventsModal', false);
      commit('loadingModal', true);
      let response = await axios.get(`/api/get-person-events/${getters.selectedPersonId}`);
      commit('personEvents', response.data.records);
      commit('loadingModal', false);
    } catch (error) {
      commit('hideEventsModal', true);
      if (error.response.status === 500) {
        console.error('getting 500!');
        alert('Server is not responding, please try again later');
      } else if (error.response.status === 404) {
        console.error('getting 404!');
        alert('We could not find the Person events, please try again later');
      } else if (error.response.status === 401) {
        alert('Your session seems to have ended, please refresh');
      } else if (error.response.status === 400) {
        alert(
          'Your request could not be proccessed, please try to refresh your page or contact support',
        );
      }
      console.log(error);
    }
  },
  async getPersonSurveys({ getters, commit }) {
    try {
      commit('loadingPersonSurveys', true);
      let response = await axios.get(
        `/api/get-person-surveys/${getters.personEventData[1].Id}/${getters.personEventData[0].Id}`,
      );
      commit('personSurveys', response.data.surveys);
      commit('loadingPersonSurveys', false);
    } catch (error) {
      if (error.response.status === 500) {
        console.error('getting 500!');
        alert('Server is not responding, please try again later');
      } else if (error.response.status === 404) {
        console.error('getting 404!');
        alert('We could not find the Person surveys, please try again later');
      } else if (error.response.status === 401) {
        alert('Your session seems to have ended, please refresh');
      } else if (error.response.status === 400) {
        alert(
          'Your request could not be proccessed, please try to refresh your page or contact support',
        );
      }
      commit('loadingPersonSurveys', false);
      console.log(error);
    }
  },
  async getPersonQuestionModel({ getters, commit }) {
    try {
      commit('loadingPersonQuestionModel', true);
      commit('showPersonQuestionModel', false);
      let eventId = getters.personEventData[1].Id;
      let personId = getters.personEventData[0].Id;
      let urlParameters = `${eventId}/${personId}`;
      if (getters.personEventData[2] !== undefined) {
        let surveyId = getters.personEventData[2].surveyId;
        urlParameters = `${eventId}/${personId}/${surveyId}`;
      }
      let response = await axios.get(`/api/get-person-survey-questions/${urlParameters}`);
      commit(
        'personQuestionModel',
        response.data[getters.personEventData[1].Question_Container__r.Name],
      );
      getters.personEventData[2] =
        response.data[getters.personEventData[1].Question_Container__r.Name].surveys;
      getters.personEventData[3] = 'create/edit';
      commit('showPersonQuestionModel', true);
      commit('loadingPersonQuestionModel', false);
    } catch (error) {
      if (error.response.status === 500) {
        console.error('getting 500!');
        alert('Server is not responding, please try again later');
      } else if (error.response.status === 404) {
        console.error('getting 404!');
        alert('We could not find the Person survey questions, please try again later');
      } else if (error.response.status === 401) {
        alert('Your session seems to have ended, please refresh');
      } else if (error.response.status === 400) {
        alert(
          'Your request could not be proccessed, please try to refresh your page or contact support',
        );
      }
      commit('showPersonSurveys', true);
      console.log(error);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
